<ng-container  *ngIf="hasResponse; else noData">
    <app-strengths-weakness-chart [data$]="radarChartDataSubject$"></app-strengths-weakness-chart>
</ng-container>

<ng-template #noData>
    <span>Aucune donnée pour l'instant</span>  
</ng-template>